import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';
import { style } from 'typestyle';
import { ContentDefinitions } from '../../../models/contentDefinitions';
import { SearchResultItem } from '../../../models/SearchResultTypes';
import { ConnectedFavoriteToggle } from '../../Favorites/FavoriteToggle';
import { StyledCellFormatter } from '../StyledCellWrapper';

export function FavoriteCell(): React.Factory<BodyCell.Props> {
  return StyledCellFormatter(
    React.createFactory(
      // eslint-disable-next-line react/display-name
      class extends React.Component<BodyCell.Props, any> {
        render() {
          if (
            !ContentDefinitions[(this.props.row.data as SearchResultItem).contentType].favoritable() ||
            this.props.row.data.isAccessDenied
          ) {
            return null;
          }
          return (
            <span className={FavoriteButtonCell} data-tb-test-id={'favorite-' + this.props.row}>
              <ConnectedFavoriteToggle searchResultItem={this.props.row.data as SearchResultItem} />
            </span>
          );
        }
      }
    )
  );
}

export const FavoriteButtonCell = style({
  display: 'inline-block',
  verticalAlign: 'middle',
  width: '38px', // $dataGridRowHeight - $lineWidth
  height: '38px',
  lineHeight: '38px',
  position: 'relative',
  top: '6px',
  left: '6px',
});
